// Tracks pending `webrtc:invite` events the current agent hasn't yet
// accepted or rejected. One entry per session — a re-invite for the same
// session just refreshes the timestamp.

import { create } from 'zustand';
import type { AgentId, SessionId, VisitorId } from '@prakash-software/shared';

export interface IncomingCall {
  sessionId: SessionId;
  /** Who is calling — visitor for visitor-initiated, agent for agent-initiated. */
  from: VisitorId | AgentId;
  fromName: string;
  /** The party this invite is addressed to (us). */
  to: AgentId | VisitorId;
  at: number;
}

interface IncomingCallsState {
  calls: Map<SessionId, IncomingCall>;
  push: (call: IncomingCall) => void;
  drop: (sessionId: SessionId) => void;
  clear: () => void;
}

export const useIncomingCallsStore = create<IncomingCallsState>((set) => ({
  calls: new Map(),
  push: (call) =>
    set((s) => {
      const next = new Map(s.calls);
      next.set(call.sessionId, call);
      return { calls: next };
    }),
  drop: (sessionId) =>
    set((s) => {
      if (!s.calls.has(sessionId)) return s;
      const next = new Map(s.calls);
      next.delete(sessionId);
      return { calls: next };
    }),
  clear: () => set({ calls: new Map() }),
}));
